// MercadoPagoNote.jsx — aviso sobre pago sin cuenta de Mercado Pago, compartido por Persona y Empresa.

import React from 'react'

function MercadoPagoNote() {
  return (
    <div className="card" style={{ padding: 24, fontSize: 12, color: "var(--fg-dim)", lineHeight: 1.55 }}>
      Nosotros utilizamos Mercado Pago. Si no tienes una cuenta, selecciona una tarjeta en la
      sección "Sin cuenta de Mercado Pago" en la ventana que te aparecerá al hacer clic en "Donar".
    </div>
  );
}

export { MercadoPagoNote };
